import { gql } from "@uplift-ltd/apollo";

export const AUTHOR_INFO_FRAGMENT = gql`
  fragment AuthorInfoFragment on CourseAuthor {
    id
    url
    name
    slug
    courseAuthorFields {
      title
    }
  }
`;
